import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png?format=webp&w=200";
import logoFallback from "@/assets/logo.png";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Services", path: "/services" },
  { name: "International", path: "/international-services" },
  { name: "Packages & Pricing", path: "/packages" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <picture>
              <source srcSet={logo} type="image/webp" />
              <img
                src={logoFallback}
                alt="Bookkeeping Services SA"
                className="h-14 sm:h-16 w-auto"
                width={64}
                height={64}
                fetchPriority="high"
                decoding="async"
              />
            </picture>
            <div className="text-left">
              <span className="font-heading text-base sm:text-xl font-bold text-foreground leading-tight block">
                Bookkeeping Services
              </span>
              <span className="block text-xs sm:text-sm font-semibold text-muted-foreground">South Africa</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link text-sm ${isActive(link.path) ? "nav-link-active" : ""}`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/book-a-call">
              <Button className="btn-primary gap-2">
                <Phone className="w-4 h-4" />
                Book a Call
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-foreground"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-border animate-fade-in">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link py-2 ${isActive(link.path) ? "nav-link-active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
              <Link to="/book-a-call" onClick={() => setIsOpen(false)}>
                <Button className="btn-primary w-full gap-2 mt-2">
                  <Phone className="w-4 h-4" />
                  Book a Call
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
